import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import addjob from '../../css/style.module.css';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const AddTimesheet = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [partnerId, setPartnerId] = useState('');
  const [partnerName, setPartnerName] = useState('');
  const [partnerList, setPartnerList] = useState([]);

  const [userId, setUserId] = useState('');
  const [users, setUsers] = useState([]);

  const [toTime, setToTime] = useState('');
  const [fromTime, setFromTime] = useState('');
  const [status, setStatus] = useState('');
  const [isUserlistLoading, setIsUserListLoading] = useState(false);

  const handleSubmit = async () => {
    const payload = {
      toTime,
      fromTime,
      jobStatus: status,
      date: toTime.split('T')[0],
      ...(partnerId && { staffId: partnerId }),
      ...(userId && { user: userId }),
    };

    await postApi(endPoints.addtimesheet, payload, {
      setLoading,
      successMsg: 'Timesheet added successfully!',
      errorMsg: 'Failed to add timesheet!',
    });

    setShow(true);

    setTimeout(() => {
      setShow(false);
      navigate('/timesheet-Management');
    }, 2000);
  };

  const fetchPartner = async () => {
    await getApi(endPoints.getallstaff, {
      setResponse: setPartnerList,
      setLoading,
      errorMsg: 'Failed to fetch partners!',
    });
  };

  const fetchUsers = async () => {
    await getApi(endPoints.getalluser(1, 99999), {
      setResponse: setUsers,
      setLoading: setIsUserListLoading,
      errorMsg: 'Failed to fetch user!',
    });
  };

  useEffect(() => {
    fetchPartner();
    fetchUsers();
  }, []);

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={'Successfully Added'}
      />

      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>Add Timesheet</h6>
          </div>
          <div className={addjob.rightbuttons}>
            <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
              <p>View Timesheets</p>
            </div>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>Timesheet Details</h6>
            </div>

            {/* EMPLOYEE */}
            <div className={addjob.addjobinputs}>
              <label>Select Employee*</label>
              <select
                value={partnerId}
                onChange={(e) => {
                  const selectedPartner = partnerList?.data?.find(
                    (cat) => cat._id === e.target.value
                  );
                  setPartnerId(e.target.value);
                  setPartnerName(selectedPartner?.name || '');
                }}
              >
                <option value="">Select Partner</option>
                {partnerList?.data?.map((partner) => (
                  <option key={partner._id} value={partner._id}>
                    {partner.firstName} {partner.lastName}
                  </option>
                ))}
              </select>
            </div>

            <div className={addjob.addjobinputs}>
              <label>Select User</label>
              <select value={userId} onChange={(e) => setUserId(e.target.value)}>
                <option value="">Select User</option>
                {users?.data?.docs?.map((user) => (
                  <option key={user._id} value={user._id}>
                    {`${user.firstName} ${user.lastName}` || user.username || user.email}
                  </option>
                ))}
              </select>
            </div>

            <div className={addjob.addnewbanner}>
              <div className={addjob.addjobtopic}>
                <h6>Timings</h6>
              </div>

              <div className={addjob.addvouchercontainer}>
                <div className={addjob.addjobinputs}>
                  <label>Start Date *</label>
                  <input
                    type="datetime-local"
                    value={toTime}
                    onChange={(e) => setToTime(e.target.value)}
                  />
                </div>

                <div className={addjob.addjobinputs}>
                  <label>End Date*</label>
                  <input
                    type="datetime-local"
                    value={fromTime}
                    onChange={(e) => setFromTime(e.target.value)}
                  />
                </div>

                <div className={addjob.addjobinputs}>
                  <label>Status*</label>
                  <select onChange={(e) => setStatus(e.target.value)} value={status}>
                    <option value="">Select</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                    <option value="Upcoming">Upcoming</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className={addjob.rightbuttons}>
              <button onClick={handleSubmit} style={{ background: '#F05423' }} disabled={loading}>
                {loading ? 'Adding...' : 'Add'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(AddTimesheet);
